import { render, staticRenderFns } from "./AvaliacoesCarousel.vue?vue&type=template&id=05cb8ab4&scoped=true"
import script from "./AvaliacoesCarousel.vue?vue&type=script&lang=js"
export * from "./AvaliacoesCarousel.vue?vue&type=script&lang=js"
import style0 from "./AvaliacoesCarousel.vue?vue&type=style&index=0&id=05cb8ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb8ab4",
  null
  
)

export default component.exports